var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Precios Hora"}}),_c('formulario-precios-hora',{attrs:{"precios-hora":_vm.preciosHora},on:{"submit":_vm.actualizar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }